import { render, staticRenderFns } from "./BannerFacturacion.vue?vue&type=template&id=0f12f4c8&scoped=true"
import script from "./BannerFacturacion.vue?vue&type=script&lang=js"
export * from "./BannerFacturacion.vue?vue&type=script&lang=js"
import style0 from "./BannerFacturacion.vue?vue&type=style&index=0&id=0f12f4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12f4c8",
  null
  
)

export default component.exports